module.exports = __webpack_public_path__ + "img/card-contract-document-configuration.e22be3a1.svg";